import { createSlice } from "@reduxjs/toolkit";

export const intiaSubContractorLocalState = {
  name: "",
  aka_name: "",
  contact_name: "",
  email: "",
  phone: "",
  address: "",
  notes: "",
};

const initialState = {
  subContractors: [],
  subContractorDetails: null,
  newSubContractorLocal: intiaSubContractorLocalState,
  userRoles: [],
  pagination: {},
  isAddSubContractorSuccess: false,
  isDeleteResponseSuccess: false,
  isUpdateSubContractorLeadSuccess: false,
};

export const subContractorSlice = createSlice({
  name: "subContractor",
  initialState,
  reducers: {
    getAllSubContractorAction: (state, { payload }) => {},
    setAllSubContractorAction: (state, { payload }) => {
      const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.subContractors = payload?.list;
      state.pagination = pagination;
    },

    addSubContractorAction: (state, { payload }) => {},
    setAddSubContractorResponse: (state, { payload }) => {
      state.isAddSubContractorSuccess = payload;
    },

    getSingleSubContractorAction: (state, { payload }) => {},
    setSingleSubContractorAction: (state, { payload }) => {
      state.subContractorDetails = payload;
    },

    deleteSubContractorAction: (state, { payload }) => {},
    setDeleteSubContractorResponse: (state, { payload }) => {
      state.isDeleteResponseSuccess = payload;
    },

    setNewSubContractorLocal: (state, action) => {
      state.newSubContractorLocal = action.payload;
    },
    resetNewSubContractorLocal: (state) => {
      state.newSubContractorLocal = intiaSubContractorLocalState;
    },

    updateSubContractorLeadAction: (state, { payload }) => {},
    setUpdateSubContractorLeadResponse: (state, { payload }) => {
      state.isUpdateSubContractorLeadSuccess = payload;
    },
  },
});

const {
  getAllSubContractorAction,
  setAllSubContractorAction,
  addSubContractorAction,
  setAddSubContractorResponse,
  setNewSubContractorLocal,
  resetNewSubContractorLocal,
  deleteSubContractorAction,
  setDeleteSubContractorResponse,
  getSingleSubContractorAction,
  setSingleSubContractorAction,
  updateSubContractorLeadAction,
  setUpdateSubContractorLeadResponse,
} = subContractorSlice.actions;

export {
  getAllSubContractorAction,
  setAllSubContractorAction,
  addSubContractorAction,
  setAddSubContractorResponse,
  setNewSubContractorLocal,
  resetNewSubContractorLocal,
  deleteSubContractorAction,
  setDeleteSubContractorResponse,
  getSingleSubContractorAction,
  setSingleSubContractorAction,
  updateSubContractorLeadAction,
  setUpdateSubContractorLeadResponse,
};

export default subContractorSlice.reducer;
